import React from "react";

export default function Contact() {
    return (
        <div className="min-h-screen bg-white px-6 md:px-20 py-20">
            <h1 className="font-display text-4xl mb-8">Contact Us</h1>

            <div className="max-w-xl space-y-6 text-sm font-sans text-gray-600">

                <p>
                    Our support team is here to help. Reach out to us using the details
                    below.
                </p>

                <p>
                    <strong>Email:</strong> support@AURÉNE.com
                </p>

                <p>
                    <strong>Phone:</strong> +1 800 123 4567
                </p>

                <p>
                    <strong>Address:</strong> AURÉNE Headquarters, New York, USA
                </p>

            </div>
        </div>
    );
}